import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    const intended = `${location.pathname}${location.search}${location.hash}`;
    const redirectParam = intended && intended !== "/" ? `?redirect=${encodeURIComponent(intended)}` : "";
    return <Navigate to={`/auth${redirectParam}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
